<template lang="pug">
div
    tabs
    router-view
</template>

<script>
import Tabs from '@/components/Tabs'
export default {
    name: 'ProteinComponent',
    components: { Tabs },
    data: function() {
        return {}
    }
}
</script>

<style lang="scss">

</style>
